import { render, staticRenderFns } from "./UnauthorizedPage.vue?vue&type=template&id=3c3a32a3&scoped=true&"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=js&"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=js&"
import style0 from "./UnauthorizedPage.vue?vue&type=style&index=0&id=3c3a32a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3a32a3",
  null
  
)

export default component.exports